import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-marker-vehicle',
  templateUrl: './marker-vehicle.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarkerVehicleComponent {
  readonly delay = input<number | null>();

  private readonly utilsService = inject(UtilsService);

  readonly hasDelay = computed(() => this.delay() != null);
  readonly isLate = computed(() => this.utilsService.isLate(this.delay()));
  readonly displayedDelay = computed(() => this.utilsService.displayedDelay(this.delay()));
}
